var map = {
	"./decidim/avatar-multiuser.png": 7581,
	"./decidim/brands/google.svg": 87232,
	"./decidim/cc-badge.png": 28363,
	"./decidim/decidim-logo.svg": 49055,
	"./decidim/default-avatar.svg": 70515,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 77241,
	"./decidim/icons.svg": 50018,
	"./decidim/pattern.png": 53377,
	"./decidim/placeholder-card-g.svg": 76494,
	"./decidim/placeholder-card-l.svg": 99269,
	"./decidim/placeholder.jpg": 33716,
	"./decidim/remixicon.symbol.svg": 70006,
	"./decidim/vendor/leaflet/layers-2x.png": 62227,
	"./decidim/vendor/leaflet/layers.png": 12682,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 14639,
	"./decidim/vendor/leaflet/marker-icon.png": 32582,
	"./decidim/vendor/leaflet/marker-shadow.png": 12733,
	"./decidim/vendor/social-share-button/douban.svg": 88761,
	"./decidim/vendor/social-share-button/email.svg": 98010,
	"./decidim/vendor/social-share-button/facebook.svg": 77810,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 33470,
	"./decidim/vendor/social-share-button/hacker_news.svg": 60058,
	"./decidim/vendor/social-share-button/linkedin.svg": 55112,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 72545,
	"./decidim/vendor/social-share-button/pinterest.svg": 45860,
	"./decidim/vendor/social-share-button/reddit.svg": 74110,
	"./decidim/vendor/social-share-button/telegram.svg": 70239,
	"./decidim/vendor/social-share-button/tumblr.svg": 49788,
	"./decidim/vendor/social-share-button/twitter.svg": 6895,
	"./decidim/vendor/social-share-button/vkontakte.svg": 50829,
	"./decidim/vendor/social-share-button/wechat.svg": 56496,
	"./decidim/vendor/social-share-button/whatsapp.svg": 74224,
	"./decidim/vendor/social-share-button/x.svg": 38106,
	"./decidim/vendor/social-share-button/xing.svg": 39886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23138;